module.exports = __webpack_public_path__ + "static/media/KARAN ACOUSTICSMASTER COLLECTION  LINE B PRE-AMPLIFIER.0a81c771.png";